import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const WebsiteSectionsDialog = ({
  open,
  onClose,
  componentSearch,
  onSearchChange,
  componentLibrary,
  onAddSection,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 0,
        border: '1px solid rgba(15, 23, 42, 0.1)',
        boxShadow: '0 28px 60px rgba(15, 23, 42, 0.2)',
      },
    }}
  >
    <DialogTitle
      sx={{
        py: 1.2,
        borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
        background: 'linear-gradient(180deg, #F8FAFC 0%, #FFFFFF 100%)',
        fontWeight: 760,
      }}
    >
      Add Website Sections
    </DialogTitle>
    <DialogContent sx={{ pt: 1.25, background: '#F8FAFC' }}>
      <Paper
        elevation={0}
        sx={{
          mb: 1.4,
          p: 1.2,
          border: '1px solid rgba(15,23,42,0.08)',
          background: '#FFFFFF',
        }}
      >
        <Typography
          sx={{
            fontSize: '0.74rem',
            fontWeight: 800,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'text.secondary',
          }}
        >
          Showcase Library
        </Typography>
        <Typography sx={{ mt: 0.35, fontSize: '0.9rem', fontWeight: 700, color: 'text.primary' }}>
          Premium sections for school websites
        </Typography>
        <Typography sx={{ mt: 0.5, fontSize: '0.82rem', lineHeight: 1.65, color: 'text.secondary' }}>
          Designed for a sharper showcase-site feel with stronger visual hierarchy, cleaner cards, and better school storytelling.
        </Typography>
      </Paper>
      <TextField
        size="small"
        fullWidth
        placeholder="Search sections like hero, experience, gallery, results..."
        value={componentSearch}
        onChange={(event) => onSearchChange(event.target.value)}
        sx={{ mb: 1.4, '& .MuiOutlinedInput-root': { background: '#FFFFFF', borderRadius: 0 } }}
      />
      <Grid container spacing={1.5}>
        {componentLibrary.map((componentType) => (
          <Grid item xs={12} sm={6} md={4} key={componentType.id}>
            <Card
              variant="outlined"
              sx={{
                borderRadius: 0,
                border: '1px solid rgba(15,23,42,0.1)',
                height: '100%',
                background: '#FFFFFF',
                transition: 'transform 180ms ease, box-shadow 180ms ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 16px 28px rgba(15, 23, 42, 0.12)',
                },
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <Stack direction="row" spacing={0.7} alignItems="center" flexWrap="wrap" sx={{ mb: 0.8 }}>
                  <Box
                      sx={{
                        px: 0.75,
                        py: 0.35,
                        fontSize: '0.68rem',
                        fontWeight: 800,
                        letterSpacing: '0.08em',
                        textTransform: 'uppercase',
                        color: 'text.secondary',
                        background: 'rgba(15,23,42,0.05)',
                        borderRadius: 0.5,
                      }}
                  >
                    {componentType.category || 'Section'}
                  </Box>
                  {componentType.recommended ? (
                    <Box
                      sx={{
                        px: 0.75,
                        py: 0.35,
                        fontSize: '0.68rem',
                        fontWeight: 800,
                        letterSpacing: '0.08em',
                        textTransform: 'uppercase',
                        color: '#92400E',
                        background: 'rgba(245,158,11,0.14)',
                        borderRadius: 0.5,
                      }}
                    >
                      Recommended
                    </Box>
                  ) : null}
                </Stack>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                  {componentType.label}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ minHeight: 42, mt: 0.7, mb: 1.2 }}>
                  {componentType.description}
                </Typography>
                <Button size="small" variant="contained" onClick={() => onAddSection(componentType.id)}>
                  Add
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
        {!componentLibrary.length && (
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2.2, borderRadius: 0, textAlign: 'center', background: '#FFFFFF' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                No matching sections
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.6 }}>
                Try a different search word like `hero`, `experience`, `gallery`, or `results`.
              </Typography>
            </Paper>
          </Grid>
        )}
      </Grid>
    </DialogContent>
    <DialogActions sx={{ px: 2, py: 1.1, borderTop: '1px solid rgba(15, 23, 42, 0.08)', background: '#FFFFFF' }}>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default WebsiteSectionsDialog;
